import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideoLoading = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 39 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.9946 39.9999C8.94897 39.997 -0.00296801 31.0403 7.38183e-07 19.9947C0.00296948 8.94905 8.95967 -0.00296801 20.0054 7.38177e-07C27.549 0.00203198 34.4497 4.24843 37.8513 10.9816C38.4524 12.2246 37.9321 13.7196 36.6891 14.3207C35.4781 14.9064 34.0208 14.4288 33.3913 13.2399C29.6581 5.84452 20.6367 2.87562 13.2412 6.60874C5.84577 10.3419 2.87687 19.3633 6.60999 26.7588C10.3431 34.1542 19.3646 37.1231 26.76 33.39C29.61 31.9514 31.9267 29.641 33.373 26.7949C33.9994 25.5642 35.5048 25.0744 36.7355 25.7008C37.9662 26.3272 38.456 27.8326 37.8296 29.0633C34.4301 35.7872 27.5291 40.019 19.9946 39.9999Z",
		fill: "currentColor"
	})
});
export default SvgVideoLoading;
